<template>
  <div class="out_box" ref="root">
    <div class="inner_search" id="sp_search">
      <!--      {{searchCount}}-->
      <el-form
          id="forms"
          ref="ruleFormRef"
          :model="searchForm"
          class="demo-ruleForm"
      >
        <div class="top" style="display: flex;flex-direction: row;justify-content: space-between;">
          <div class="left_box">
            <el-form-item :label-width="isSetting?71:67" :label="$t('common.bybranch')+':'" v-if="adminShow"
                          prop="managerId">
              <!-- 分管人 -->
              <el-select
                  :disabled="isRuleLock"
                  v-model="searchForm.managerId"
                  class="m-2"
                  size="small"
                  style="margin-bottom: 0px !important;"
                  :default-first-option="true"
                  @change="selectMore($event)"
              >
                <el-option
                    v-for="item in tableDataSelect"
                    :label="item.userName"
                    :value="item.userId"
                    :key="item.id"
                />
              </el-select>
            </el-form-item>
          </div>
          <div class="right_box">
            <el-input
                :disabled="isRuleLock"
                style="width: 400px;margin-right: 10px"
                v-model="searchCount"
                :placeholder="$t('common.please.holder.search')"
                class="input-with-select"
                clearable
                size="small"
                @clear="handleSearchInput('clear')"
                @keydown.enter.native="handleSearchInput('search')"
            >
              <template #append>
                <ElButton :disabled="isRuleLock" type="primary" size="small" @click="handleSearchInput('search')"
                          style="font-size: 13px !important;">
                  {{ $t('common.search') }}
                </ElButton>
              </template>
            </el-input>
            <el-button :disabled="isRuleLock" size="small" @click="changeDrawer">
              {{ $t('common.reset') }}
            </el-button>
          </div>
        </div>
        <div v-if="drawer" class="bottom"
             style="display: flex;justify-content: space-between;align-items: center;flex-wrap: wrap">
          <!--            <el-form-item id="customerCode" :label="$t('common_customer_number')+':'" prop="customerCode"-->
          <!--                          v-if="searchShow">-->
          <!--              <el-input-->
          <!--                  style="width: 150px"-->
          <!--                  v-model="searchForm.customerCode"-->
          <!--                  :placeholder="$t('common.please.input')"-->
          <!--                  size="small"-->
          <!--              />-->
          <!--            </el-form-item>-->
          <!-- 客户名称 -->
          <!--            <el-form-item :label="$t('common_customer_name')+':'" prop="customerName">-->
          <!--              <el-input-->
          <!--                  style="width: 150px"-->
          <!--                  v-model="searchForm.customerName"-->
          <!--                  :placeholder="$t('common.please.input')"-->
          <!--                  size="small"-->
          <!--              />-->
          <!--            </el-form-item>-->
          <!-- 所属地区 -->
          <el-form-item :label="$t('common.customer.Region')+':'" prop="zoneAddress">
            <el-select
                :disabled="isRuleLock"
                filterable
                multiple
                clearable
                collapse-tags
                collapse-tags-tooltip
                :reserve-keyword="false"
                :max-collapse-tags="1"
                v-model="searchForm.zoneAddressList"
                class="m-2"
                size="small"
                :placeholder="$t('common.please.select')"
            >
              <el-option
                  v-for="item in areaList"
                  :key="item.country"
                  :label="lang!=='zh-CN'?item.countryEn:item.country"
                  :value="lang!=='zh-CN'?item.countryEn:item.country"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('common.customer.source')+':'" prop="customerOrigin">
            <SelectEditTag :disabled="isRuleLock" v-model:selectedMember="searchForm.customerOriginList"
                           ref="selectTagOrigin"
                           :typeSelect="1" :isShowEmpty="true" :managerId="searchForm.managerId"></SelectEditTag>
          </el-form-item>
          <el-form-item :label="$t('common.interest.product')+':'" prop="product">
            <SelectEditTag :disabled="isRuleLock" v-model:selectedMember="searchForm.productList"
                           ref="selectTagProduct"
                           :typeSelect="2" :isShowEmpty="true" :managerId="searchForm.managerId"></SelectEditTag>
          </el-form-item>
          <!-- 客户等级 -->
          <el-form-item :label="$t('common.customer.type')+':'" prop="customerTypeId">
            <el-select
                :disabled="isRuleLock"
                filterable
                multiple
                clearable
                collapse-tags
                collapse-tags-tooltip
                :reserve-keyword="false"
                :max-collapse-tags="1"
                v-model="searchForm.customerTypeIdList"
                class="m-2"
                size="small"
                :placeholder="$t('common.please.select')"
                @change="handleChange"
            >
              <el-option
                  v-for="item in sortList(tableData)"
                  :key="item === '' ? '__empty__' : item.labelName"
                  :label="item.customerType"
                  :value="item.id"
                  :disabled="searchForm.customerTypeIdList?.includes('')"
              />
              <el-option key="empty" :label="empty" :value="''"></el-option>
            </el-select>
          </el-form-item>
          <!--            <el-form-item :label="$t('common.customer.email')+':'" prop="email" v-if="searchShow">-->
          <!--              <el-input-->
          <!--                  style="width: 150px"-->
          <!--                  v-model="searchForm.email"-->
          <!--                  size="small"-->
          <!--                  :placeholder="$t('common.customer.email.placeholder')"-->
          <!--              />-->
          <!--            </el-form-item>-->
          <!--            <el-form-item :label="$t('common.contact')+':'" prop="contactName">-->
          <!--              <el-input-->
          <!--                  style="width: 150px"-->
          <!--                  v-model="searchForm.contactName"-->
          <!--                  :placeholder="$t('common.please.input')"-->
          <!--                  size="small"-->
          <!--              />-->
          <!--            </el-form-item>-->

          <!--            <el-input-->
          <!--                style="width: 150px"-->
          <!--                v-model="searchForm.createBy"-->
          <!--                :placeholder="$t('common.please.input')"-->
          <!--                size="small"-->
          <!--            />-->
          <CreateCustomerSelect :disabled="isRuleLock" :isTree="isTree"
                                v-model="searchForm.createByList"></CreateCustomerSelect>
          <el-form-item :label-width="auto" :label="$t('last.time')+':'" prop="targetTime">
            <el-date-picker
                :disabled="isRuleLock"
                v-model="searchForm.targetTime"
                type="daterange"
                size="small"
                style="width: 200px !important;"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                date-format="YYYY/MM/DD"
                :placeholder="$t('common.please.select')"
                :aria-placeholder="$t('common.please.select')"
            />
          </el-form-item>
          <slot v-if="isMarketing" name="Birthday"></slot>
          <slot v-if="isMarketing" name="Marketing"></slot>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  computed,
  onMounted,
  reactive,
  defineEmits, watch, nextTick,
} from "vue";
import {useStore} from "vuex";
import {throttle} from "@/utils/mylodash"
import {i18n} from "@/lang";
import {useRoute} from "vue-router";
import CreateCustomerSelect from "@/components/Select/CreateCustomerSelect.vue";
import SelectEditTag from "@/components/SelectEditTag.vue";
import {Storage} from "@/utils/storage"
import sessionStore from "@/utils/sessionStore";
import {sortList} from "@/utils/cache";
import {auto} from "@popperjs/core";

const store = useStore();
const emits = defineEmits();
const route = useRoute()
// 区域列表
const areaList = computed(() => store.state.customer.areaList);
// 客户等级
const tableData = computed(() => store.state.cusList.tableData);
const customerSelectData = computed(() => store.state.cusList.customerSelectData);
const teamId = computed(() => store.state.email.teamID);
const searchCount = ref('');
const isClear = ref(false);
//是否点击搜索或者高级搜索按钮,页数从1开始计算
const isSearch = ref(false);

const empty = ref(i18n.global.t('select.empty'))

// 假设 Storage.get 是同步的
const raw = Storage.get('STEP_1_RULE') || {}
// 不需要把 saved 设成空的 ref 再去读
// 邮箱筛选
const saved = ref(raw)
// search 表单
const searchForm = ref({
  customerName: isMarketing ? saved.value.customerName || "" : "",
  managerId: isMarketing ? saved.value.managerId || "" : "",
  zoneAddress: isMarketing ? saved.value.zoneAddress || "" : "",
  zoneAddressList: isMarketing ? saved.value.zoneAddressList || [] : [],
  customerTypeId: isMarketing ? saved.value.customerTypeId || null : null,
  customerTypeIdList: isMarketing ? saved.value?.customerTypeIdList ?? [] : [],
  valueTarget: isMarketing ? saved.value.valueTarget || "" : "",
  targetTime: isMarketing ? saved.value.targetTime || [] : [],
  email: isMarketing ? saved.value.email || "" : "",
  customerCode: isMarketing ? saved.value.customerCode || "" : "",
  customerOrigin: isMarketing ? saved.value.customerOrigin || null : null,
  customerOriginList: isMarketing ? saved.value.customerOriginList || [] : [],
  product: isMarketing ? saved.value.product || null : null,
  productList: isMarketing ? saved.value.productList || [] : [],
  createBy: isMarketing ? saved.value.createBy || "" : "",
  createByList: isMarketing ? saved.value.createByList || [] : [],
  search: searchCount.value,
});
const drawer = ref(true);
const direction = ref('rtl')
const labelPosition = ref('top');
// 权限控制
const isSuperAdmin = computed(() => store.getters["user/isSuperAdmin"])
const isAdmin = computed(() => store.getters["user/isAdmin"])
// 语言
const lang = computed(() => store.state.system.langLocal)
// 分管列表
const tableDataSelect = computed(() => {
  return isSuperAdmin.value || isAdmin.value ? [...store.state.groups.AllTableData, {
    userName: i18n.global.t('common.all'),
    userId: 'all',
  }] : store.state.groups.AllTableData;
});
// 传递参数
const {adminShow, searchShow, isTree, isSetting, isMarketing} = defineProps({
  adminShow: {
    type: Boolean,
    default: false,
  },
  searchShow: {
    type: Boolean,
    default: false
  },
  isDias: {
    type: Boolean,
    default: true,
  },
  isTree: {
    type: Boolean,
    default: false
  },
  isSetting: {
    type: Boolean,
    default: false,
  },
//   是否是营销
  isMarketing: {
    type: Boolean,
    default: false
  },
//   是否锁定条件
  isRuleLock: {
    type: Boolean,
    default: false,
  }
});

const selectTagOrigin = ref(null)
const selectTagProduct = ref(null)

async function selectMore() {
  console.log(searchForm.value.managerId, 'searchForm.value.managerId')
  if (selectTagOrigin.value) {
    selectTagOrigin.value.getTagList(searchForm.value.managerId)
  }
  if (selectTagProduct.value) {
    selectTagProduct.value.getTagList(searchForm.value.managerId)
  }
}

const userInfo = computed(() => store.state.user.userInfo)
onMounted(async () => {
  // 第一次加载
  if (!isMarketing) {
    delete searchForm.value.customerOriginList;
    delete searchForm.value.productList;
    delete searchForm.value.zoneAddressList;
    delete searchForm.value.createByList;
    delete searchForm.value.customerTypeIdList;
  }
  await store.dispatch("groups/getAllUserList", {teamId: teamId.value});
  console.log(sessionStore.get("countryList"), 'sessionStore.getItem("countryList")')
  // 检查 sessionStorage 中是否存在 countryList
  await store.dispatch('customer/getAreaNames');
  if (sessionStore.get("customerLevel") === null) {
    await store.dispatch("cusList/getMailCustomerLevel", {teamId: teamId.value})
  }
  if (tableDataSelect.value.length >= 1) {
    searchForm.value.managerId = adminShow ? tableDataSelect.value.find(_ => _.userId === userInfo.value.id).userId : "";
  }
  await getSelectTarget()
  // const searchPayload = getSearchPayload()
  emits("searchKey", searchForm.value);
});
// 客户来源，客户意向产品
const getSelectTarget = async () => {
  console.log(searchForm.value.managerId, 'searchForm.value.managerId')
  if (selectTagOrigin.value) {
    selectTagOrigin.value.getTagList(searchForm.value.managerId)
  }
  if (selectTagProduct.value) {
    selectTagProduct.value.getTagList(searchForm.value.managerId)
  }
}
// 表单dom
const ruleFormRef = ref(null);
// 表单重制
const resetForms = throttle((formEl) => {
  // ruleFormRef.value.resetFields();
  if (tableDataSelect.value.length >= 1) {
    searchForm.value.managerId = adminShow ? tableDataSelect.value.find(_ => _.userId === userInfo.value.id).userId : "";
  }
  if (searchForm.value.managerId === "all") {
    searchForm.value.managerId = ""
  }
  searchCount.value = ''
  searchForm.value = {
    customerName: "",
    zoneAddress: "",
    customerTypeId: null,
    valueTarget: '',
    targetTime: [],
    email: '',
    customerCode: '',
    customerOrigin: null,
    // customerOriginList:[],
    product: null,
    managerId: searchForm.value.managerId,
    // productList:[],
    search: searchCount.value,
  }
  const searchPayload = getSearchPayload()
  console.log(searchPayload, searchCount.value, 'searchPayload')
  emits("searchKey", searchPayload);
}, 3000);
// 搜索提交
const onSubmit = throttle((formEl) => {
  const searchPayload = getSearchPayload()
  emits("searchKey", searchPayload);
}, 3000);


const getSearchPayload = () => {
  const {
    targetTime,
    customerOrigin,
    productList,
    zoneAddressList,
    createByList,
    customerOriginList,
    customerTypeId,
    customerTypeIdList,
  } = searchForm.value

  const startTime = targetTime?.[0] ? `${targetTime[0]} 00:00:00` : null
  const endTime = targetTime?.[1] ? `${targetTime[1]} 23:59:59` : null

  // 拷贝一份，避免修改原始 searchForm.value
  const search = {...searchForm.value}

  // 优先级逻辑（互斥条件）
  if (customerTypeIdList?.length > 0) {
    delete search.customerTypeId
  } else if (customerOriginList?.length > 0) {
    delete search.customerOrigin
  } else if (productList?.length > 0) {
    delete search.product
  } else if (zoneAddressList?.length > 0) {
    delete search.zoneAddress
  } else if (createByList?.length > 0) {
    delete search.createBy
  }

  // 对于 List 类型，额外清理
  if (!customerOriginList?.length) {
    search.customerOrigin = null
    delete search.customerOriginList
  }
  if (!productList?.length) {
    search.product = null
    delete search.productList
  }

  return {
    ...search,
    startTime,
    endTime,
  }
}

const checkAll = ref(false)
const indeterminate = ref(false)
watch(() => searchForm.value.valueTarget, (val) => {
  if (val.length === 0) {
    checkAll.value = false
    indeterminate.value = false
  } else if (val.length === tableData.value.length) {
    checkAll.value = true
    indeterminate.value = false
  } else {
    indeterminate.value = true
  }
})

watch(() => teamId.value, (val) => {
  if (val) {
    getSelectTarget()
  }
})

const handleCheckAll = (val) => {
  indeterminate.value = false
  if (val) {
    searchForm.value.valueTarget = tableData.value.map((_) => _.id)
  } else {
    searchForm.value.valueTarget = []
  }
}

function handleSearchInput(flag) {
  if (flag === "clear") {
    isClear.value = true
  } else if (flag === 'search') {
    isSearch.value = true
  } else {
    isClear.value = false
  }
  searchForm.value.search = searchCount.value
  const searchPayload = getSearchPayload()
  emits("searchKey", searchPayload);
}


const root = ref(null)

function getElement() {
  return root.value; // 返回真实的dom元素
}

const changeDrawer = () => {
  // drawer.value = !drawer.value
  resetForms()
  emits("changeDra", drawer.value)
}

const handleChange = async (val) => {
  // 如果选择了 empty，则清空其他选项，只保留 empty
  if (val.includes("")) {
    searchForm.value.customerTypeIdList = [""];
    return;
  }

  // 如果之前选了 empty，然后又选了别的，移除 empty
  const emptyIndex = val.indexOf("");
  if (emptyIndex !== -1 && val.length > 1) {
    val.splice(emptyIndex, 1);
    searchForm.value.customerTypeIdList = [...val];
  }
}

defineExpose({
  getElement,
  getSelectTarget,
})
</script>

<style lang="less" scoped>
:deep(.el-form-item) {
  float: left;
  font-size: 13px;
  color: rgba(0, 0, 0, .85) !important;
  margin-bottom: 0px !important;
}

.left_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;

}

.right_box {
  width: max-content;
  display: flex;
  justify-content: center;
  align-items: center;

  & > :deep(.el-form-item) {
    margin-right: 0px !important;
    float: left;
  }
}

#forms {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

:deep(.el-form-item__label) {
  color: rgba(0, 0, 0, .85) !important;
  font-size: 13px !important;
}

:deep(.el-form-item:last-child) {
  float: right;
}

:deep(.el-form-item__content) {
  margin: 0px !important;
}


:deep(.el-tabs__header) {
  margin-bottom: 0px !important;
}

:deep(.el-select) {
  width: 200px !important;
}

:deep(.el-form-item__label) {
  font-weight: normal !important;
}

.el-select-dropdown__item {
  min-width: auto !important;
  width: auto;
  max-width: 300px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-menu-wrapper {
  min-width: auto !important;
  width: auto;
  max-width: 300px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

:deep(.el-dropdown-menu__item) {
  min-width: auto !important;
  width: auto;
  max-width: 300px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inherit !important;
}

:deep(.el-input-group__append) {
  padding: 0 20px 0 0;
}

:deep(.el-input-group__append button.el-button) {
  background: #5a9cf8;
  color: white;
  width: 76px;
  border-radius: 0px 4px 4px 0px !important;
}

:deep(.el-input__inner) {
  font-size: 13px !important;
}

:deep(.el-select__input) {
  font-size: 13px !important;
}

:deep(.el-tag) {
  max-width: 100px !important;
}
</style>
